import { EnvironmentSports } from '@bcf-shared-settings/settings/types';

export const environment: EnvironmentSports = {} as any;
